import React from 'react'
import withNavigation from '../hoc/withNavigation/withNavigation';

const Help = () =>
{
    return(<div>
      Help
    </div>)
}

export default withNavigation(Help, {backgroundColor:'#FFFFFF', showSideMenu:true});